<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">INTRODUCTION</p>
<p class="noindent">Culver City boasts a rich history, from the Native Americans and early settlers to visionary Harry H. Culver’s dream for a balanced community through development and major redevelopment. Culver City continues to thrive as the “Heart of Screenland.” Just walk around downtown Culver City at lunchtime and you’ll see that studio IDs are a reminder of the presence of the entertainment industry and its broad base of support. Although many locals still miss the MGM sign, Sony Pictures Entertainment has been an extraordinary corporate citizen for more than twenty years.</p>
<p class="indent">The Gabrielinos used this land with respect, leaving fertile ground for the generations of early settler families like the Machados, Talamantes, Higueras, Ybarras, Saenz, Rochas, Lugos and others.</p>
<p class="indent">Statehood and other changes yielded new opportunities that city founder Harry Culver noted and used to develop the kind of community that brought families together in his “Home City.” Culver’s business acumen laid the foundation for an economic base that ensures a good, solid life with all the amenities.</p>
<p class="indent">Harry Culver’s leadership brought people to a temperate place halfway between the growing pueblo of Los Angeles and Abbot Kinney’s resort of Venice. He planned for success and the promise of a little community growing out toward the big city.</p>
<p class="indent">This is the story of the many people who shared the common goals that have yielded Culver City—an oasis within the urban metropolis and a city with a rich history.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?8e0da1a0